var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99145 8.69992L8.33782 10.3536C8.14255 10.5488 7.82597 10.5488 7.63071 10.3536L5.99142 8.71427L2.69276 12H13.2785L9.99145 8.69992ZM10.6986 7.99281L14 11.3073V4.69137L10.6986 7.99281ZM13.2772 4H2.69137L7.98426 9.29289L13.2772 4ZM2 4.72284V11.2786L5.28431 8.00716L2 4.72284ZM1 4.49754C1 3.67049 1.67134 3 2.4985 3H13.5015C14.3291 3 15 3.67014 15 4.49754V11.5025C15 12.3295 14.3287 13 13.5015 13H2.4985C1.67093 13 1 12.3299 1 11.5025V4.49754Z", fill: "#303030" })
  );
});